import "./App.css";
import Error403 from "./pages/Error403";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import AdminPrivateRoute from "./routes/AdminPrivateRoute.js";
import AdminPublicRoute from "./routes/AdminPublicRoute.js";
import RoleProtectedRoute from "./routes/RoleProtectedRoute.js";
import ProposalView from "./pages/proposal/ProposalView";
import DashboardLayout from "./layout/DashboardLayout.js";
import Dashboard from "./pages/dashboard/Dashboard.js";
import Login from "./pages/auth/Login.js";
import AddClient from "./pages/client/Profile.js";
import RegistrationForm from "./pages/auth/RegistrationForm.js";
import Role from "./pages/roleManagement/List.js";
import User from "./pages/userManagement/List.js";
import ProjectModules from "./pages/projectModules/List.js";
import Type from "./pages/typeManagement/List.js";
import Group from "./pages/groupManagement/List.js";
import Source from "./pages/sourceManagement/List.js";
// import LeadSetting from "./pages/leadSetting/List.js";
import List from "./pages/leadsetting/List.js";
import LeadManagement from "./pages/leadManagement/List.js";
import LeadDetailsList from "./pages/leadManagement/LeadDetails.js";
import ProjectProgress from "./pages/projectProgress/List.js";
import Template from "./pages/template/List.jsx";
import SellTemplate from "./pages/sellTemplate/List.jsx";
import ChatPage from "./pages/chatWindow/chat/ChatPage.js";
import CreateAgreement from "./pages/agreement/CreateAgreement";
import AddProposal from "./pages/proposal/AddProposal.js";
import PackageList from "./pages/projectPackage/List.js";
import AgreementView from "./pages/agreement/AgreementView.js";
import DocumentCreate from "./pages/document/CreateDocument.js";
import DocumentView from "./pages/document/DocumentView";
import AgreementAcceptPage from "./pages/agreement/AgreementAcceptPage.js";
import PaymentList from "./pages/Payment/List.js";
import AgreementOTPView from "./pages/agreement/AgreementOTPView";
import AgreementPaymentView from "./pages/agreement/AgreementPaymentView";
import PaymentSuccess from "./pages/Payment/PaymentSuccess";
import PaymentFailed from "./pages/Payment/PaymentFailed";
import PackageView from "./pages/projectPackage/View";
import ProjectList from "./pages/project/List.js";
import ProjectDetails from "./pages/project/ProjectDetails.js";
import CreateProject from "./pages/project/CreateProject.js";
import AssignedTesting from "./pages/assignedTesting/List";
import BugList from "./pages/bugs/List";
import MyBugs from "./pages/bugs/MyBugs";
import BugDetails from "./pages/bugs/Details";
import DeveloperProjectDetails from "./pages/project/DeveloperProjectDetails";
import TesterProjectDetails from "./pages/project/TesterProjectDetails";
import PublicBooking from "./pages/meeting/PublicBooking";
import MyAvailability from "./pages/meeting/MyAvailability";
import ZohoConnect from "./pages/meeting/ZohoConnect";
import BookingSuccess from "./pages/meeting/BookingSuccess";
import MyMeetings from "./pages/meeting/MyMeetings";
import TesterProjects from "./pages/project/TesterProjects";
import TestingProjectDetails from "./pages/dashboard/TestingProjectDetails";
import GoogleConnect from "./pages/meeting/GoogleConnect";
import TestCases from "./pages/testCases/List";
import TestCaseDetails from "./pages/testCases/Details";
import TestingReports from "./pages/testingReports/List.js";
import LeadShuffle from "./pages/leadsetting/LeadShuffle.js";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* PUBLIC */}
        <Route element={<AdminPublicRoute />}>
          <Route path="/" element={<Login />} />
          my-meetings
        </Route>

        <Route
          path="/LeadRegistration/:sourcename?"
          element={<RegistrationForm />}
        />

        <Route
          path="lead-edit/:id"
          element={
            <RoleProtectedRoute module="lead">
              <RegistrationForm />
            </RoleProtectedRoute>
          }
        />

        <Route path="/booking-success" element={<BookingSuccess />} />
        <Route path="/book-meeting/:slug" element={<PublicBooking />} />
        <Route path="/agreement/view/:id" element={<AgreementView />} />
        <Route path="/agreement/accept/:id" element={<AgreementAcceptPage />} />
        <Route path="/document/view/:id" element={<DocumentView />} />
        <Route path="/agreement/otp/:id" element={<AgreementOTPView />} />
        <Route path="/payment-success/:id" element={<PaymentSuccess />} />

        <Route path="/payment-failed/:id" element={<PaymentFailed />} />
        <Route
          path="/agreement/payment/:id"
          element={<AgreementPaymentView />}
        />

        {/* PRIVATE */}
        <Route element={<AdminPrivateRoute />}>
          <Route element={<DashboardLayout />}>
            <Route
              path="dashboard"
              element={
                <RoleProtectedRoute module="Dashboard">
                  <Dashboard />
                </RoleProtectedRoute>
              }
            />
            <Route path="/google-connect" element={<GoogleConnect />} />
            <Route
              path="/my-availability"
              element={
                <RoleProtectedRoute action="read" module="my-availability">
                  <MyAvailability />
                </RoleProtectedRoute>
              }
            />

            <Route
              path="/my-meetings"
              element={
                <RoleProtectedRoute action="read" module="my-meetings">
                  <MyMeetings />
                </RoleProtectedRoute>
              }
            />

            <Route
              path="payments"
              element={
                <RoleProtectedRoute module="leadfinal">
                  <PaymentList />
                </RoleProtectedRoute>
              }
            />

            <Route
              path="projects"
              element={
                <RoleProtectedRoute module="project">
                  <ProjectList />
                </RoleProtectedRoute>
              }
            />

            <Route
              path="create-project"
              element={
                <RoleProtectedRoute module="project">
                  <CreateProject />
                </RoleProtectedRoute>
              }
            />

            <Route
              path="create-project/:leadId"
              element={
                <RoleProtectedRoute module="project">
                  <CreateProject />
                </RoleProtectedRoute>
              }
            />

            <Route
              path="testing/project/:id"
              element={
                <RoleProtectedRoute module="assigned-testing">
                  <ProjectDetails />
                </RoleProtectedRoute>
              }
            />

            <Route
              path="project/:id"
              element={
                <RoleProtectedRoute module="project">
                  <ProjectDetails />
                </RoleProtectedRoute>
              }
            />

            <Route
              path="developer-project/:id"
              element={
                <RoleProtectedRoute module="project">
                  <DeveloperProjectDetails />
                </RoleProtectedRoute>
              }
            />

            <Route
              path="testing-project/:id"
              element={
                <RoleProtectedRoute module="assigned-testing">
                  <TestingProjectDetails />
                </RoleProtectedRoute>
              }
            />

            <Route
              path="assigned-testing"
              element={
                <RoleProtectedRoute module="assigned-testing">
                  <AssignedTesting />
                </RoleProtectedRoute>
              }
            />

            <Route
              path="/tester-projects"
              element={
                <RoleProtectedRoute module="assigned-testing">
                  <TesterProjects />
                </RoleProtectedRoute>
              }
            />

            <Route
              path="/tester-project/:id"
              element={
                <RoleProtectedRoute module="assigned-testing">
                  <TesterProjectDetails />
                </RoleProtectedRoute>
              }
            />

            <Route
              path="/test-cases"
              element={
                <RoleProtectedRoute module="test-cases">
                  <TestCases />
                </RoleProtectedRoute>
              }
            />

            <Route
              path="/test-cases/:projectId"
              element={<TestCaseDetails />}
            />
            {/* MY BUGS */}

            <Route
              path="/my-bugs"
              element={
                <RoleProtectedRoute module="assigned-bugs">
                  <MyBugs />
                </RoleProtectedRoute>
              }
            />

            {/* BUG MANAGEMENT */}

            <Route
              path="/bugs"
              element={
                <RoleProtectedRoute module="bugs">
                  <BugList />
                </RoleProtectedRoute>
              }
            />

            {/* BUG DETAILS */}

            <Route
              path="/bugs/:projectId"
              element={
                <RoleProtectedRoute module="bugs">
                  <BugDetails />
                </RoleProtectedRoute>
              }
            />

            <Route
              path="/testing-reports"
              element={
                <RoleProtectedRoute module="testing-reports">
                  <TestingReports />
                </RoleProtectedRoute>
              }
            />

            <Route path="403" element={<Error403 />} />

            <Route
              path="add-client"
              element={
                <RoleProtectedRoute module="addClient">
                  <AddClient />
                </RoleProtectedRoute>
              }
            />

            <Route
              path="type"
              element={
                <RoleProtectedRoute module="type">
                  <Type />
                </RoleProtectedRoute>
              }
            />

            <Route
              path="group"
              element={
                <RoleProtectedRoute module="group">
                  <Group />
                </RoleProtectedRoute>
              }
            />

            <Route
              path="source"
              element={
                <RoleProtectedRoute module="source">
                  <Source />
                </RoleProtectedRoute>
              }
            />

            <Route
              path="role"
              element={
                <RoleProtectedRoute module="role">
                  <Role />
                </RoleProtectedRoute>
              }
            />

            <Route
              path="leadSetting"
              element={
                <RoleProtectedRoute module="leadassign">
                  <List />
                </RoleProtectedRoute>
              }
            />

            <Route
  path="lead-shuffle"
  element={
    <RoleProtectedRoute module="leadassign">
      <LeadShuffle />
    </RoleProtectedRoute>
  }
/>

            <Route
              path="new-user"
              element={
                <RoleProtectedRoute module="user">
                  <User />
                </RoleProtectedRoute>
              }
            />

            <Route
              path="lead-management"
              element={
                <RoleProtectedRoute module="lead">
                  <LeadManagement />
                </RoleProtectedRoute>
              }
            />

            <Route
              path="lead-details/:id"
              element={
                <RoleProtectedRoute module="lead">
                  <LeadDetailsList />
                </RoleProtectedRoute>
              }
            />

            <Route
              path="template"
              element={
                <RoleProtectedRoute module="template">
                  <Template />
                </RoleProtectedRoute>
              }
            />

            <Route
              path="sell-template"
              element={
                <RoleProtectedRoute module="selltemplate">
                  <SellTemplate />
                </RoleProtectedRoute>
              }
            />

            <Route
              path="project-modules"
              element={
                <RoleProtectedRoute module="projectmodules">
                  <ProjectModules />
                </RoleProtectedRoute>
              }
            />

            <Route
              path="project-package"
              element={
                <RoleProtectedRoute module="projectpackage">
                  <PackageList />
                </RoleProtectedRoute>
              }
            />

            <Route
              path="project-package/view/:id"
              element={
                <RoleProtectedRoute module="projectpackage">
                  <PackageView />
                </RoleProtectedRoute>
              }
            />

            <Route
              path="project-progress"
              element={
                <RoleProtectedRoute module="project">
                  <ProjectProgress />
                </RoleProtectedRoute>
              }
            />

            <Route
              path="chat"
              element={
                <RoleProtectedRoute module="chat">
                  <ChatPage />
                </RoleProtectedRoute>
              }
            />

            <Route
              path="proposal/create/:id"
              element={
                <RoleProtectedRoute module="leadfinal">
                  <AddProposal />
                </RoleProtectedRoute>
              }
            />

            <Route
              path="/assigned-testing/:id"
              element={<TestingProjectDetails />}
            />
          </Route>

          {/* <Route
            path="agreement/create/:leadId"
            element={
              <RoleProtectedRoute module="leadfinal">
                <CreateAgreement />
              </RoleProtectedRoute>
            }
          /> */}

          <Route
            path="document/create/:leadId"
            element={
              <RoleProtectedRoute module="leadfinal">
                <DocumentCreate />
              </RoleProtectedRoute>
            }
          />

          <Route
            path="project-package"
            element={
              <RoleProtectedRoute module="projectpackage">
                <PackageList />
              </RoleProtectedRoute>
            }
          />

          <Route
            path="proposals/:id"
            element={
              <RoleProtectedRoute module="leadfinal">
                <ProposalView />
              </RoleProtectedRoute>
            }
          />
        </Route>
      </Routes>

      <ToastContainer />
    </BrowserRouter>
  );
}

export default App;
